export default __webpack_public_path__ + "static/image5-9fe955e64de1d67c1416085ff966ef31.webp";